export const PAGE_SIZE = 25;
export const EXPAND_ICON_COLUMN_INDEX = 6;
export const OUT_OF_STOCK = 'Out of Stock';
